var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content" }, [
    _c(
      "div",
      { staticClass: "grid-view" },
      [
        _c(
          "div",
          { staticClass: "main-content" },
          [
            _c(
              "search-item",
              {
                attrs: {
                  "config-module": "231512",
                  reset: true,
                  "custom-sim-query-placeholder": _vm.$t(
                    "Message.QuickSearchBusinessNo"
                  )
                },
                on: {
                  "click-more": function(value) {
                    return (_vm.isAdvancedQuery = value)
                  },
                  simSearchItemCallBack: _vm.toSimpleQuery,
                  advSearchItemCallBack: _vm.toAdvancedQuery
                }
              },
              [
                _c(
                  "div",
                  { attrs: { slot: "operations" }, slot: "operations" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { disabled: _vm.total <= 0, type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.statistics_clickHandler()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.Statistics")))]
                    )
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              {
                staticClass: "section grid-wrapper",
                staticStyle: { "min-height": "350px" }
              },
              [
                _c("cargo-ag-grid", {
                  staticClass: "ag-theme-balham",
                  staticStyle: { width: "100%" },
                  attrs: {
                    "config-module": "23151200",
                    "grid-options": _vm.gridOptions,
                    "side-bar": {
                      toolPanels: ["columns", "filter"],
                      visible: false
                    },
                    "column-defs": _vm.columnDefs,
                    "row-data": _vm.rowData,
                    "grid-params": _vm.gridParams,
                    "enable-col-resize": true,
                    "enable-sorting": true,
                    "check-main-record": false,
                    "deselect-main-record": false
                  },
                  on: {
                    "update:gridParams": function($event) {
                      _vm.gridParams = $event
                    },
                    "update:grid-params": function($event) {
                      _vm.gridParams = $event
                    },
                    gridReady: _vm.onGridReady
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pagination-wrapper" },
              [
                _c("cargo-pagination", {
                  attrs: {
                    "config-module": "23151200",
                    total: _vm.total,
                    page: _vm.filter.pageNum,
                    limit: _vm.filter.pageSize
                  },
                  on: {
                    "update:page": function($event) {
                      return _vm.$set(_vm.filter, "pageNum", $event)
                    },
                    "update:limit": function($event) {
                      return _vm.$set(_vm.filter, "pageSize", $event)
                    },
                    pagination: function() {
                      if (_vm.total > 0) {
                        _vm.toQuery()
                      }
                    }
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _vm.statisticsDialog.visible
          ? _c(
              "el-dialog",
              {
                directives: [
                  { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
                ],
                attrs: {
                  visible: _vm.statisticsDialog.visible,
                  title: _vm.$t("SeaExport.Statistics"),
                  width: _vm.$selectByLang("360px", "445px"),
                  "close-on-click-modal": false
                },
                on: {
                  "update:visible": function($event) {
                    return _vm.$set(_vm.statisticsDialog, "visible", $event)
                  }
                }
              },
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      "label-width": _vm.$selectByLang("85px", "170px"),
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: { label: _vm.$t("SeaExport.Slaves") }
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "160px" },
                          attrs: { disabled: true },
                          model: {
                            value: _vm.statisticsDialog.txtSlaves,
                            callback: function($$v) {
                              _vm.$set(_vm.statisticsDialog, "txtSlaves", $$v)
                            },
                            expression: "statisticsDialog.txtSlaves"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: { label: _vm.$t("SeaExport.TotalTickets") }
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "160px" },
                          attrs: { disabled: true },
                          model: {
                            value: _vm.statisticsDialog.txtCount,
                            callback: function($$v) {
                              _vm.$set(_vm.statisticsDialog, "txtCount", $$v)
                            },
                            expression: "statisticsDialog.txtCount"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: { label: _vm.$t("SeaExport.CustomerCount") }
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "160px" },
                          attrs: { disabled: true },
                          model: {
                            value: _vm.statisticsDialog.txtCustomerCount,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.statisticsDialog,
                                "txtCustomerCount",
                                $$v
                              )
                            },
                            expression: "statisticsDialog.txtCustomerCount"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { staticClass: "custom", attrs: { label: "20＇" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "160px" },
                          attrs: { disabled: true },
                          model: {
                            value: _vm.statisticsDialog.txt20,
                            callback: function($$v) {
                              _vm.$set(_vm.statisticsDialog, "txt20", $$v)
                            },
                            expression: "statisticsDialog.txt20"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { staticClass: "custom", attrs: { label: "40＇" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "160px" },
                          attrs: { disabled: true },
                          model: {
                            value: _vm.statisticsDialog.txt40,
                            callback: function($$v) {
                              _vm.$set(_vm.statisticsDialog, "txt40", $$v)
                            },
                            expression: "statisticsDialog.txt40"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { staticClass: "custom", attrs: { label: "40HQ＇" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "160px" },
                          attrs: { disabled: true },
                          model: {
                            value: _vm.statisticsDialog.txt40hq,
                            callback: function($$v) {
                              _vm.$set(_vm.statisticsDialog, "txt40hq", $$v)
                            },
                            expression: "statisticsDialog.txt40hq"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { staticClass: "custom", attrs: { label: "45＇" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "160px" },
                          attrs: { disabled: true },
                          model: {
                            value: _vm.statisticsDialog.txt45,
                            callback: function($$v) {
                              _vm.$set(_vm.statisticsDialog, "txt45", $$v)
                            },
                            expression: "statisticsDialog.txt45"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { staticClass: "custom", attrs: { label: "TEU" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "160px" },
                          attrs: { disabled: true },
                          model: {
                            value: _vm.statisticsDialog.txtTeu,
                            callback: function($$v) {
                              _vm.$set(_vm.statisticsDialog, "txtTeu", $$v)
                            },
                            expression: "statisticsDialog.txtTeu"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: { label: _vm.$t("SeaExport.Weight2") }
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "160px" },
                          attrs: { disabled: true },
                          model: {
                            value: _vm.statisticsDialog.txtWeight,
                            callback: function($$v) {
                              _vm.$set(_vm.statisticsDialog, "txtWeight", $$v)
                            },
                            expression: "statisticsDialog.txtWeight"
                          }
                        }),
                        _c("span", [_vm._v("KGS")])
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: { label: _vm.$t("SeaExport.Cubage") }
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "160px" },
                          attrs: { disabled: true },
                          model: {
                            value: _vm.statisticsDialog.txtCubage,
                            callback: function($$v) {
                              _vm.$set(_vm.statisticsDialog, "txtCubage", $$v)
                            },
                            expression: "statisticsDialog.txtCubage"
                          }
                        }),
                        _c("span", [_vm._v("CBM")])
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: { label: _vm.$t("SeaExport.ChargedWeight") }
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "160px" },
                          attrs: { disabled: true },
                          model: {
                            value: _vm.statisticsDialog.txtChargeWeight,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.statisticsDialog,
                                "txtChargeWeight",
                                $$v
                              )
                            },
                            expression: "statisticsDialog.txtChargeWeight"
                          }
                        }),
                        _c("span", [_vm._v("M/T")])
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: { label: _vm.$t("SeaExport.SpecifyAgentNumber") }
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "160px" },
                          attrs: { disabled: true },
                          model: {
                            value: _vm.statisticsDialog.txtdesignationAgentNum,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.statisticsDialog,
                                "txtdesignationAgentNum",
                                $$v
                              )
                            },
                            expression:
                              "statisticsDialog.txtdesignationAgentNum"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { attrs: { slot: "footer" }, slot: "footer" },
                  [
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function($event) {
                            _vm.statisticsDialog.visible = false
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.Close")))]
                    )
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm.salesRequireDialog.visible
          ? _c(
              "el-dialog",
              {
                directives: [
                  { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
                ],
                attrs: {
                  visible: _vm.salesRequireDialog.visible,
                  title: _vm.$t("SeaExport.SalesRequire"),
                  width: "360px"
                },
                on: {
                  "update:visible": function($event) {
                    return _vm.$set(_vm.salesRequireDialog, "visible", $event)
                  }
                }
              },
              [
                _c("el-input", {
                  attrs: {
                    type: "textarea",
                    rows: 15,
                    readonly: !_vm.salesRequireDialog.isEdit
                  },
                  model: {
                    value: _vm.salesRequireDialog.salesRequire,
                    callback: function($$v) {
                      _vm.$set(_vm.salesRequireDialog, "salesRequire", $$v)
                    },
                    expression: "salesRequireDialog.salesRequire"
                  }
                }),
                _c(
                  "div",
                  { attrs: { slot: "footer" }, slot: "footer" },
                  [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.salesRequireDialog.isEdit,
                            expression: "salesRequireDialog.isEdit"
                          }
                        ],
                        attrs: { type: "primary" },
                        on: { click: _vm.enterSalesRequire }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.Submission")))]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.salesRequireDialog.isEdit,
                            expression: "!salesRequireDialog.isEdit"
                          }
                        ],
                        on: {
                          click: function($event) {
                            _vm.salesRequireDialog.visible = false
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.Close")))]
                    )
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }